import type { SingleSelectOption } from "../components/common";

export interface IndianAddressData {
  states: string[];
  districts: Record<string, string[]>;
  pincodes: Record<string, string[]>;
}

let cachedData: IndianAddressData | null = null;

export async function loadIndianAddressData(): Promise<IndianAddressData> {
  if (cachedData) return cachedData;
  const mod = await import("indian_address");
  cachedData = {
    states: mod.states,
    districts: mod.districts as Record<string, string[]>,
    pincodes: mod.pincodes as Record<string, string[]>,
  };
  return cachedData;
}

export function stateToKey(stateName: string): string {
  return stateName.trim().toLowerCase();
}

export function cityToKey(cityName: string): string {
  return cityName.trim().toLowerCase();
}

export function getPincodeLookupKey(stateName: string, cityName: string): string {
  return `${stateToKey(stateName)}_${cityToKey(cityName)}`;
}

export function getDistrictsForState(
  data: IndianAddressData,
  stateName: string
): string[] {
  return data.districts[stateToKey(stateName)] ?? [];
}

export function getPincodesForStateCity(
  data: IndianAddressData,
  stateName: string,
  cityName: string
): string[] {
  return data.pincodes[getPincodeLookupKey(stateName, cityName)] ?? [];
}

export function toLocationSelectOptions(items: string[]): SingleSelectOption[] {
  return items.map((item) => ({ label: item, value: item }));
}
